/**
 * Options class for Retrier
 */
export class RetrierOptions {
  constructor() {
    this.retries = RetrierOptions.RETRIES_DEFAULT;
    this.retryIntervalMs = void 0;
    this.timeoutMsValue = void 0;
    this.onTry = void 0;
    this.onSuccess = void 0;
    this.onFail = void 0;
  }
  /**
   * The default value for retries
   */
  /**
   * How many times should retry the operation
   */
  get Retries() {
    return this.retries;
  }
  set Retries(v) {
    this.retries = v;
  }

  /**
   * The default interval between retries
   */

  /**
   * The interval between tries in milliseconds
   */
  get RetryIntervalMs() {
    return this.retryIntervalMs !== undefined ? this.retryIntervalMs : RetrierOptions.RETRY_INTERVAL_MS_DEFAULT;
  }
  set RetryIntervalMs(v) {
    this.retryIntervalMs = v;
  }

  /**
   * The default timeout in millisecs
   */

  /**
   * The Timeout interval in milliseconds
   */
  get timeoutMs() {
    return this.timeoutMsValue !== undefined ? this.timeoutMsValue : RetrierOptions.TIMEOUT_MS_DEFAULT;
  }
  set timeoutMs(v) {
    this.timeoutMsValue = v;
  }

  /**
   * Optional callback, triggered right before each try
   */

  /**
   * Optional callback, triggered on success
   */

  /**
   * Optional callback, triggered on fail (timeout or too many retries)
   */
}
RetrierOptions.RETRIES_DEFAULT = 10;
RetrierOptions.RETRY_INTERVAL_MS_DEFAULT = 10;
RetrierOptions.TIMEOUT_MS_DEFAULT = 1000;
//# sourceMappingURL=retrier-options.js.map